export const CollectionListDropDown = (function () {
  // Store dropdown instances to access them later
  const dropdowns = {};
 
  function initDropDown(selector, onChange, initialValue) {
    const container = document.querySelector(selector);
    const dropdown = document.querySelector(`${selector}.w-dropdown`);
    const dropdownToggle = container.querySelector(`${selector} .w-dropdown-toggle`); 
    const dropdownList = container.querySelector(`${selector} .w-dropdown-list`);
    const selectedItemValueContainer = container.querySelector(`${selector} .dropdown-selected-value`);
    const collectionItems = container.querySelectorAll(`${selector} .dropdown-item`);
    
    // Store this dropdown instance data for later access
    dropdowns[selector] = {
      container,
      dropdown,
      dropdownToggle,
      dropdownList,
      selectedItemValueContainer,
      collectionItems,
      onChange
    };
    
    collectionItems.forEach(item => {
      item.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link behavior if using Link Blocks
        const selectedOption = this;
        selectDropDownElement(selector, selectedOption);
       
        onChange && onChange(selectedOption);
        // Close the dropdown
        dropdownList.classList.remove('w--open'); // Close the dropdown
        // Move focus away to reset dropdown behavior
        dropdown.blur();
      });
    });
        
    if (initialValue) {
      const item = getElementByItemValue(selector, initialValue);
      if (item) { 
        setTimeout(() => {
          item.click(); // Simulate a click on the matching item to activate filter
        }, 200);
      }
    }
  }
  
  function selectDropDownElement(selector, selectedItem) {
    const dropdown = dropdowns[selector];
    if (!dropdown) return;
    
    const selectedItemValueContainer = dropdown.selectedItemValueContainer;
    
    while (selectedItemValueContainer.firstChild) {
      selectedItemValueContainer.removeChild(selectedItemValueContainer.firstChild);
    }
    
    const sourceElement = selectedItem;
    if (sourceElement) {
      const clonedElement = sourceElement.cloneNode(true);
      selectedItemValueContainer.appendChild(clonedElement);
      const currentValue = sourceElement.getAttribute('data-value');
      dropdown.dropdown.setAttribute('data-current-value', currentValue);
    } else {
      console.error("SelectedItem Element not found.", selectedItem);
    }
  }
  
  function getElementByItemValue(selector, value) {
    const dropdown = dropdowns[selector];
    return Array.from(dropdown.collectionItems).find((x) => {
      return x.getAttribute('data-value') === value;
    });
  }
  
  // Public methods
  return {
    init: function({ selector, onChange, initialValue }) {
      document.addEventListener('DOMContentLoaded', function() {
        initDropDown(selector, onChange, initialValue);
      });
    },
    // Add a new public method to change dropdown value from outside
    setValue: function(selector, value) {
      const item = getElementByItemValue(selector, value);
      if (item) {
        item.click(); // Trigger the click event on the item
      } else if (value !== undefined && value !== null) {
        console.error(`No item with value '${value}' found in dropdown '${selector}'`);
      }
    },
    // Get currently selected dropdown value
    getValue: function(selector) {
      const dropdown = dropdowns[selector];
      return dropdown.dropdown.getAttribute('data-current-value');
    }
  };
})();